import m from "../../geodata/es2015/hongKongLow";
window.am4geodata_hongKongLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/hongKongLow.js
// module id = null
// module chunks = 